export const getRewardRoundingSettings = (pointRoundingConfiguration) => {
  const rewardRule = pointRoundingConfiguration?.find(
    (configuration) =>
      Number(configuration?.pointSettingsName ?? configuration?.PointSettingsName) === 1 ||
      String(configuration?.pointSettingsName ?? configuration?.PointSettingsName ?? "").toUpperCase() ===
        "REWARDRULE",
  );

  const settings =
    rewardRule?.pointsSettingsType ?? rewardRule?.PointsSettingsType ?? {};

  return {
    roundMethod: settings?.roundMethod ?? settings?.RoundMethod,
    roundDigits: settings?.roundDigits ?? settings?.RoundDigits,
  };
};

export const getMinimumEnabledDenomination = (denominations) => {
  const enabledValues = (Array.isArray(denominations) ? denominations : [])
    .filter((denomination) => denomination?.enabled === true)
    .map((denomination) => Number(denomination?.denomination))
    .filter((value) => Number.isFinite(value) && value > 0);

  return enabledValues.length ? Math.min(...enabledValues) : 0;
};

export const applyRewardRounding = (value, roundMethod, roundDigits) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;

  const digits = Math.max(0, Number(roundDigits) || 0);
  const factor = 10 ** digits;

  switch (Number(roundMethod)) {
    case 0:
      // "None" does not apply rounding, regardless of RoundDigits.
      return numericValue;
    case 1:
      return Math.ceil(numericValue * factor) / factor;
    case 2:
      return Math.floor(numericValue * factor) / factor;
    case 3:
      // Match MidpointRounding.AwayFromZero used by the Order API.
      return (
        Math.sign(numericValue) *
        (Math.round(Math.abs(numericValue) * factor) / factor)
      );
    case 4:
      return Math.trunc(numericValue * factor) / factor;
    case 5:
      return Math.ceil(numericValue);
    default:
      return numericValue;
  }
};

export const calculatePercentagePoints = ({
  percentageBase,
  percentage,
  roundMethod,
  roundDigits,
}) =>
  applyRewardRounding(
    (Number(percentageBase) * Number(percentage)) / 100,
    roundMethod,
    roundDigits,
  );
